import { message } from 'antd';
import { getIntl } from 'utils/getIntl';

const intl = getIntl();

export const messageSuccessIntl = (messageId: string) => {
  message.success(intl.formatMessage({ id: messageId }));
};

export const messageErrorIntl = (messageId: string) => {
  message.error(intl.formatMessage({ id: messageId }));
};

export const formatMessageIntl = (messageId: string) => intl.formatMessage({ id: messageId });